module.exports = __webpack_public_path__ + "static/media/AngelsOfAether_Promo23.30f38768.jpg";